import { useState, useEffect } from 'react'

import themeCss from '../components/sass/theme.module.scss'
import css from './sass/auctions.module.scss'
import cardCss from '../items/sass/itemcard.module.scss'

import { formatMoney } from 'services/util'

export default function DonationGoalButton({ auction, auctionState, auctionUser, setShowDonationModal }) {

  const [totalDonations, setTotalDonations] = useState(0)
  const [userDonationTotal, setUserDonationTotal] = useState(0)

  const goal = auction?.FundraisingGoal ?? 0
  const progress = goal ? Math.min((totalDonations / goal) * 100, 100) : 0
  const displayedProgress = Math.round(progress)

  useEffect(() => {
    setTotalDonations(auction?.TotalDonations || 0)
  }, [auction])

  useEffect(() => {
    const currentAuction = auctionUser?.MyAuctions?.find(a => a.AuctionId === auction?.AuctionId)
    setUserDonationTotal(currentAuction?.DonationTotal || 0)
  }, [auction?.AuctionId, auctionUser])

  // Do not show a fundraising goal when it is disabled, incomplete, or the auction has ended.
  if (!auction?.IncludeFundraisingGoal) return <></>
  if (!auction?.FundraisingGoal) return <></>
  if (auctionState === 'ended') return <></>

  return (
    <div className={css['donation-goal-button-container']}>
      <div className={css['donation-goal-button-summary']}>
        <p className={css['donation-goal-button-context']}>
          <span className={css['donation-goal-button-amount']}>${formatMoney(totalDonations)}</span>
          {' '}raised of ${formatMoney(goal)} goal
        </p>
        <p className={css['donation-goal-button-percentage']}>{displayedProgress}%</p>
      </div>

      <div
        className={css['donation-goal-button-progress']}
        role="progressbar"
        aria-label="Donation goal progress"
        aria-valuemin="0"
        aria-valuemax="100"
        aria-valuenow={displayedProgress}>
        <div
          className={css['donation-goal-button-progress-bar']}
          style={{ width: `${progress}%` }} />
      </div>

      {auctionState === 'started' &&
        <button
          className={`${themeCss['FilledYellow']} ${themeCss['button']} ${cardCss['place-bid-button']} ${css['donation-goal-button-action']}`}
          disabled={userDonationTotal > 9999}
          onClick={() => setShowDonationModal(true)}>
          Donate toward the goal
        </button>}

      {/* {(userDonationTotal > 9999 && auctionState === 'started') &&
        <p className={css['donation-max']}>
          You have reached the maximum donation threshold, if you would like to donate more, please contact the auction administrator.
        </p>} */}
    </div>
  )
}
